import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonService } from 'src/app/Service/Common.service';
import { DashboardService } from 'src/app/Service/dashboard/dashboard.service';
import { environment } from 'src/environments/environment';


@Component({
	selector: 'app-flex-report',
	templateUrl: './flex-report.component.html',
	styleUrls: ['./flex-report.component.css'],
	encapsulation: ViewEncapsulation.None

})

export class FlexReportComponent implements OnInit {
	flexmonsterLicense: string = environment.flexLicenseKey;	
	private flexData: any;
	public projectId!: number;
	public groupId!: number;
	public newreport: any;
	public flexmonsterHeight = (screen.availHeight - 20);
	@ViewChild('flexMonsterGrid') flexMonsterGrid: any;
	constructor(private _dashboardService: DashboardService,
		private commonService: CommonService) {
	}

	ngOnInit() {
		this.projectId = this.commonService.getProjectId();
		this.groupId = this.commonService.getLoggedInUserGroupId();
		this.callAPI();
	}
	callAPI() {
		this._dashboardService.GetFlexDCIDetails({ projectId: this.projectId, groupId: this.groupId }).subscribe((res: any[]) => {
			this.flexData = res;
			if (this.flexData.length > 0) {
				this.callreportdata();
			}
		});
	}

	callreportdata() {
	
		this.newreport = {			
			global: {
				localization: {
				grid: {
				  blankMember: ""
				}
			  }
			},
			"dataSource": {
				dataSourceType: 'json',
				"data": this.flexData
			},			
			slice: {
				columns: [{
					uniqueName: "ProjectCode"  ,caption: "Project Code"
				}, {
					uniqueName: "Discipline"
				}, {
					uniqueName: "Structure" ,caption: "Structure / Package"
				}, {
					uniqueName: "DocumentNo" ,caption: "Document No"
				}, {
					uniqueName: "DocumentTitle" ,caption: "Document Title"
				}, {
					uniqueName: "DrawingSize"  ,caption: "Drawing Size"
				}, {
					uniqueName: "Stage"
				}, {
					uniqueName: "RevisionNo",caption: "Revision No"
				}, {
					uniqueName: "DocumentStatus" ,caption: "Document Status"
				}, {
					uniqueName: "Scheduled"
				}, {
					uniqueName: "Submitted"
				}, {
					uniqueName: "Approved", 
				}, {
					uniqueName: "TransmittalNo",caption: "Transmittal No"
				}, {
					uniqueName: "TransmittalDate" ,caption: "Transmittal Date"
				}, {
					uniqueName: "EngineeringManHours" ,caption: "Engineering Man Hours"
				}, {
					uniqueName: "DraftingManHours" ,caption: "Drafting Man Hours"
				}, {
					uniqueName: "Timesheet"
				}]
			},

			options: {
				grid: {
					title: "Flex Report - DCI",
					type: "flat",
					showGrandTotals: "off",
					// "grandTotalsPosition": "bottom",
					// "showHierarchies": true,
					// "showHierarchyCaptions": true,
					// "showReportFiltersArea": true,
					// "pagesFilterLayout": "horizontal",					
					//  "showTotals": "off",
				},
				configuratorActive: false
			},
			localization: {
				grid: {
				 	blankMember: ""
				}
		 	},
			width: "96%",
			height: '95%',
			customizeCell: this.customizeCellFunction,

			formats: [{
				// thousandsSeparator: ",",
				// decimalSeparator: ".",
				// decimalPlaces: 2,
				// currencySymbol: "$",
				// currencySymbolAlign: "left",
				name: "",
				nullValue: " ",
				textAlign: "left"
				
			}]

			
		};

	

	}

	 customizeCellFunction(cell: { addClass: (arg0: string) => void; }, data: { isClassicTotalRow: any; }) {	
		if (data.isClassicTotalRow) 
			cell.addClass("fm-total-classic-r");
	  }


}
